import React from 'react';
import { Android, Apple } from '@material-ui/icons';
import BIServiceCRM from 'assets/icons/svg/BIServiceCRM';
import './styles.scss';

const MobilePage: React.FC = () => {
  return (
    <div className="page-mobile">
      <BIServiceCRM />

      <p className="page-mobile__message">
        Уважаемые коллеги, скачайте и установите, пожалуйста, мобильное приложение BI CRM Service для работы с мобильных
        устройств.
      </p>

      <div className="page-mobile__links">
        <a
          href="https://play.google.com/store/apps/details?id=com.bigroup.bi_service"
          target="_blank"
          rel="noopener noreferrer"
        >
          <Android />
          <p>Скачать в Google Play</p>
        </a>

        <a href="https://apps.apple.com/kz/app/bi-crm-service/id1503304107" target="_blank" rel="noopener noreferrer">
          <Apple />
          <p>
            Скачать в<br />
            App Store
          </p>
        </a>
      </div>
    </div>
  );
};

export default MobilePage;
